import { render } from "./user_link.vue?vue&type=template&id=2cae9070"
import script from "./user_link.vue?vue&type=script&lang=js"
export * from "./user_link.vue?vue&type=script&lang=js"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__